import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import products from "../products";
import "../styles/Books.css";
import "../styles/Contact.css";
import "../styles/ProductCard.css";
import "../styles/Filters.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

function Books() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("Todos");
  const [priceMin, setPriceMin] = useState(0);
  const [priceMax, setPriceMax] = useState(500); // o lo que sea el max
  const [sort, setSort] = useState("precio-desc");
  const [toastMessage, setToastMessage] = useState("");

  const navigate = useNavigate();
  const addToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Buscar si el producto ya está en el carrito
    const existingProduct = cart.find((item) => item.id === product.id);

    if (existingProduct) {
      existingProduct.quantity = (existingProduct.quantity || 1) + 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(cart));

    // Disparar evento para actualizar contador del header
    window.dispatchEvent(new Event("storage"));

    // Mostrar mensaje de éxito
    setToastMessage(`${product.name} añadido al carrito`);
    setTimeout(() => setToastMessage(""), 2000);
  };

  useEffect(() => {
    // filtrar productos cada vez que cambie search/category/precio/orden
    let result = products;

    // filtro por búsqueda solo si search no está vacío
    if (search.trim() !== "") {
      result = result.filter((p) =>
        (p.name || "").toLowerCase().includes(search.trim().toLowerCase())
      );
    }

    // filtro por categoría solo si category no es "Todos"
    if (category !== "Todos") {
      result = result.filter((p) => p.category === category);
    }

    // filtro por precio solo si priceMin o priceMax tienen valores diferentes a los iniciales
    if (priceMin !== 0 || priceMax !== 100000) {
      result = result.filter((p) => {
        return p.price / 100 >= priceMin && p.price / 100 <= priceMax;
      });
    }

    // orden
    if (sort === "precio-asc") {
      result = result.sort((a, b) => a.price - b.price);
    } else if (sort === "precio-desc") {
      result = result.sort((a, b) => b.price - a.price);
    } else if (sort === "nombre-asc") {
      result = result.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sort === "nombre-desc") {
      result = result.sort((a, b) => b.name.localeCompare(a.name));
    }

    setFilteredProducts([...result]);
    console.log(filteredProducts);
  }, [search, category, priceMin, priceMax, sort]);

  return (
    <section className="books with-filters">
      <h2 className="books-name">Tienda</h2>

      {/* FILTROS Y ORDEN */}
      {/*
      <div className="books-filters">
        <label htmlFor="search-input">Búsqueda</label>
        <input
          id="search-input"
          type="text"
          placeholder="Buscar producto..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="filter-input"
        />

        <label htmlFor="category-select">Categoría</label>
        <select
          id="category-select"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="filter-select"
        >
          <option value="Todos">Todas las categorías</option>
          <option value="Libros">Libros</option>
          <option value="Rituales">Rituales</option>
          <option value="Talismanes">Talismanes</option>
        </select>

        <label htmlFor="sort-select">Ordenar</label>
        <select
          id="sort-select"
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="filter-select"
        >
          <option value="precio-asc">Precio: bajo a alto</option>
          <option value="precio-desc">Precio: alto a bajo</option>
          <option value="nombre-asc">Nombre A → Z</option>
          <option value="nombre-desc">Nombre Z → A</option>
        </select>
        <div className="price-filter">
          <p>
            <label>Precio</label>€ {priceMin} - € {priceMax}
          </p>
          <Slider
            range
            min={0}
            max={300}
            value={[priceMin, priceMax]}
            onChange={([min, max]) => {
              setPriceMin(min);
              setPriceMax(max);
            }}
            trackStyle={[{ backgroundColor: "#3f51b5" }]}
            handleStyle={[
              { borderColor: "#3f51b5", backgroundColor: "#3f51b5" },
              { borderColor: "#3f51b5", backgroundColor: "#3f51b5" },
            ]}
          />
        </div>
      </div>
      */}
      {/* (FILTROS DESACTIVADOS por ahora: reactivar cuando haya más productos) */}
      <p className="result-count">
        Mostrando {filteredProducts.length} de {products.length} productos
      </p>
      <div className="product-grid">
        {filteredProducts.map((product) => (
          <Link
            to={`/producto/${product.slug}`}
            key={product.id}
            className="product-card-link"
          >
            <div className="product-card">
              {product.video ? (
                <VideoPlayer videos={product.video} />
              ) : (
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
              )}
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <div className="product-footer">
                  {product.price > 0 && (
                    <>
                      <span className="product-price">
                        {(product.price / 100).toFixed(2)} €
                      </span>
                      <button
                        className="buy-button"
                        onClick={(e) => {
                          e.preventDefault();
                          addToCart(product);
                        }}
                      >
                        Comprar
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* GRID DE PRODUCTOS */}
      {toastMessage && <div className="toast">{toastMessage}</div>}
    </section>
  );
}

function VideoPlayer({ videos }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleEnded = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  return (
    <video
      src={videos[currentIndex]}
      className="product-image"
      controls
      muted
      autoPlay
      playsInline
      preload="metadata"
      onEnded={handleEnded}
    />
  );
}

export default Books;
